// BootSpace.js
import React, { useEffect, useRef, useState } from "react";
import styles from "@/components/ev-details/BootSpace.module.css";

const BootSpace = ({ litres }) => {
  const containerRef = useRef(null);
  const litresElementRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(null);
  const [litresElementWidth, setLitresElementWidth] = useState(null);

  useEffect(() => {
    setContainerWidth(containerRef.current.offsetWidth);
    setLitresElementWidth(litresElementRef.current.offsetWidth);
  }, []);

  const suitcaseEmojis = ["🧳", "🧳🧳", "🧳🧳🧳", "🧳🧳🧳🧳"];
  const thresholds = [800, 1600, 2400, 3200]; // Thresholds for each category
  let category = thresholds.length;
  let progressBarPercentage = 100;

  for (let i = 0; i < thresholds.length; i++) {
    if (litres <= thresholds[i]) {
      category = i + 1;
      progressBarPercentage =
        ((litres - (i > 0 ? thresholds[i - 1] : 0)) /
          (thresholds[i] - (i > 0 ? thresholds[i - 1] : 0))) *
        100;
      break;
    }
  }

  let adjustedProgressBarPercentage =
    (category - 1) * 25 + (progressBarPercentage * 25) / 100;

  let litresElementHalfWidthPercentage =
    (litresElementWidth / 2 / containerWidth) * 100;

  adjustedProgressBarPercentage = Math.min(
    Math.max(adjustedProgressBarPercentage, litresElementHalfWidthPercentage),
    100 - litresElementHalfWidthPercentage
  );

  return (
    <div className={styles["container"]} ref={containerRef}>
      <div className={styles["litres-container"]}>
        <div
          ref={litresElementRef}
          className={styles["litres-element"]}
          style={{ left: `${adjustedProgressBarPercentage}%` }}>
          <div className={styles["litres-number"]}>{litres}</div>
          <div className={styles["litres-unit"]}>Litres</div>
        </div>
      </div>
      <div className={styles["boot-container"]}>
        <div className={styles["boot-space"]}>
          {[...Array(4)].map((_, i) => (
            <div key={i} className={styles["boot-space-section"]}>
              <div
                className={styles["progress-bar"]}
                style={{
                  width: `${
                    i < category - 1
                      ? "100%"
                      : i === category - 1
                      ? `${Math.min(progressBarPercentage, 100)}%`
                      : "0%"
                  }`,
                }}
              />
              <span className={styles["suitcase-emoji"]}>
                {suitcaseEmojis[i]}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BootSpace;
